import FeedbackAction from "./FeedbackAction";
import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import FeedbackModel from "./models/FeedbackModel";
import IFeedbackState from "./models/IFeedbackState";

export default class FeedbackReducer extends BaseReducer<IFeedbackState> {
    public readonly initialState: IFeedbackState = {
        feedbacks: [] as FeedbackModel[],
    };

    public [FeedbackAction.FEEDBACK_ADD](state: IFeedbackState, action: IAction<FeedbackModel>): IFeedbackState {
        return {
            ...state,
            feedbacks: [...state.feedbacks, action.payload!] as FeedbackModel[],
        };
    }

    public [FeedbackAction.FEEDBACK_DELETE](state: IFeedbackState, action: IAction<string>): IFeedbackState {
        const feedbackId: string = action.payload!;

        return {
            ...state,
            feedbacks: state.feedbacks.filter((model: FeedbackModel) => model.id !== feedbackId),
        };
    }

    public [FeedbackAction.FEEDBACK_CLEAN](state: IFeedbackState, action: IAction<undefined>): IFeedbackState {
        return {
            ...state,
            feedbacks: [] as FeedbackModel[],
        };
    }
}
